import styled from 'styled-components'

export const EmptyStateDiv = styled.div`
	padding: 32px 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
`

export const EmptyStateText = styled.div`
	display: flex;
	padding: 32px 16px;

	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
`
